export const CSR_TYPES = {
    TOWER: 1,
    DOMAIN: 2,
    DC: 3,
    DOMAIN_LDAPS: 4,
    PUSH_SERVICES: 5
};
